#import "./usageDataInfo.gql"

query GetDashboardData($eventNames: [String!]!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!, $siteId: ID) {
  usageData(eventNames: $eventNames, startDate: $startDate, endDate: $endDate, siteId: $siteId) {
    ...usageDataInfo
  }
}

query GetEngagedSites(
  $eventNames: [String!]!
  $startDate: ISO8601DateTime!
  $endDate: ISO8601DateTime!
  $threshold: Int!
) {
  engagedSites(eventNames: $eventNames, startDate: $startDate, endDate: $endDate, threshold: $threshold) {
    companyName
    siteName
    date
    value
  }
}

mutation TrackUsage($eventName: String!) {
  trackUsage(eventName: $eventName) {
    success
  }
}
